module.exports = __webpack_public_path__ + "img/red_040.26a0d293.png";